import { mixins, styled } from '@bob/library'

export const OverlayWrapper = styled.div<{ show: boolean; top: number }>`
  position: fixed;
  background: ${({ theme }: { theme: any }) => theme.colors.grayLight};
  visibility: ${({ show }: { show: boolean }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }: { show: boolean }) => (show ? 1 : 0)};
  z-index: 2;
  transition: 0.25s ease-out;
  transform: ${({ show }: { show: boolean }) => (show ? 'translateY(0)' : 'translateY(-100%)')};
  top: ${({ top }: { top: number }) => top}px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  ${mixins.media.min.desktop} {
    padding-left: 7%;
    padding-right: 7%;
  }
`

export const OverlayScrollWrapper = styled.div`
  padding: 12px 16px;
  margin-top: 24px;
  padding-top: 0px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const BottomBar = styled.div`
  height: 60px;
  display: flex;
  justify-content: space-around;
  flex: none;
  align-items: center;
`
export const MobileOnlyButton = styled.button`
  ${mixins.cta.tertiary('black')}
`
